import React from 'react';
import { Row, Col, Button, Table, Skeleton, Form } from 'antd';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';

import { Card, Container, Title, GoBack } from 'src/components';
import { table } from 'src/utils';
import { IReduxState } from 'src/store';
import {
  fetchFamilies,
  removeFamily,
  updateFamily,
} from 'src/store/families/actions';

import EditableCell from './components/cell/cell.component';
import Pagination from './components/pagination/pagination.component';

import { IProps } from './families.type';
import { columns } from './families.utils';
import useFamilies from './families.use';

const FamiliesScreen: React.FC<IProps> = (props) => {
  useFamilies(props);

  const { families } = props;

  const {
    loading,
    data,
    form,
    handleFamilies,
    editingKey,
    isEditing,
    handleEdit,
    handleSave,
    handleCancel,
    handleRemove,
  } = useFamilies(props);

  const navigate = useNavigate();

  const components = {
    body: {
      cell: EditableCell,
    },
  };

  return (
    <Container type="fluid">
      <Row gutter={16} className="mt-2" align="middle" justify="space-between">
        <Col>
          <GoBack color="#444" />
          <Title
            foreword="Configurações"
            title="Famílias"
            subtitle="Visualize abaixo a lista de famílias cadastradas no sistema, clique no botão ao lado para adicionar mais."
          />
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={() => navigate('/painel/familias/novo')}
          >
            Adicionar Nova
          </Button>
        </Col>
      </Row>
      {!loading ? (
        <Row gutter={16}>
          <Col span={24}>
            <Card>
              <Form form={form} component={false}>
                <Table
                  {...table}
                  bordered
                  components={components}
                  dataSource={data}
                  rowKey={(record: any) => record.id}
                  columns={columns({
                    editingKey,
                    isEditing,
                    handleEdit,
                    handleSave,
                    handleCancel,
                    handleRemove,
                  })}
                  rowClassName="editable-row"
                  pagination={false}
                />
              </Form>
            </Card>
          </Col>
          <Col span={24}>
            <Pagination
              pagesMeta={families?.meta}
              handleSearch={handleFamilies}
            />
          </Col>
        </Row>
      ) : (
        <Row gutter={16}>
          <Col span={24}>
            <Card>
              <Skeleton active />
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
};

const mapStateToProps = (state: IReduxState) => ({
  families: state.families.all,
});

export default connect(mapStateToProps, {
  fetchFamilies,
  removeFamily,
  updateFamily,
})(FamiliesScreen);
